import * as React from 'react';
import ContentPage from 'containers/Layouts/components/ContentPage';
import { ContentData } from 'model/ContentData';
import ContentService from 'services/ContentService';
import { Grid, Paper, Skeleton } from '@mui/material';
import homeClasses from './Home.module.css';
import { trackPromise } from 'react-promise-tracker';
import AnalyticsService from 'services/AnalyticsService';
import AnalyticsData from 'model/AnalyticsData';
import { ContentType, EventType } from 'model/enums';

type IPropsHome = {};

type IStateHome = {
    content: ContentData[];
    loading: boolean;
    analyticsSent: boolean;
};
const HOME_PAGE = 'Home';

class Home extends React.Component<IPropsHome, IStateHome> {
    state = {
        content: [],
        loading: false,
        analyticsSent: false,
    };

    componentDidMount() {
        this.refreshContentPage();
        this.sendAnalytics();
    }

    render() {
        return (
            <div>
                {this.state.loading ? (
                    this.displayLoadingContent()
                ) : (
                    <ContentPage contentCards={this.state.content}></ContentPage>
                )}
            </div>
        );
    }

    displayLoadingContent = () => {
        const waitingSkeleton: React.ReactElement[] = [];
        for (let index = 0; index < 1; index++) {
            waitingSkeleton.push(this.buildCardSkeleton(index));
        }

        return (
            <div className={homeClasses.feedDiv} role="feed">
                <Grid container spacing={3}>
                    {waitingSkeleton}
                </Grid>
            </div>
        );
    };

    buildCardSkeleton = (key: number) => {
        return (
            <Grid item xs={12} md={6} lg={4} xl={3} key={key}>
                <Paper>
                    <div className={homeClasses.ghostCardContainer}>
                        <div className={homeClasses.ghostCardText}>
                            <Skeleton variant="text" style={{ width: '90%' }} />
                            <Skeleton variant="text" style={{ width: '70%' }} />
                            <Skeleton variant="text" style={{ marginTop: 50, width: '50%' }} />
                        </div>
                        <div className={homeClasses.ghostCardImg}>
                            <Skeleton variant="rectangular" width={112} height={112} />
                        </div>
                    </div>
                </Paper>
            </Grid>
        );
    };

    refreshContentPage = async () => {
        this.setState({ loading: true }, async () => {
            const data = await trackPromise(ContentService.getPatientEducation());
            this.setState({ content: data, loading: false });
        });
    };

    sendAnalytics = async () => {
        if (!this.state.analyticsSent) {
            let data: AnalyticsData = {
                eventType: EventType.Navigation,
                contentType: ContentType.Page,
                title: HOME_PAGE,
            };
            AnalyticsService.recordEvent(data);
            this.setState({
                analyticsSent: true,
            });
        }
    };
}

export default Home;
